import React from 'react';

export default class Permissable extends React.PureComponent {
  static contextTypes = {
    viewable: React.PropTypes.func,
  }

  static propTypes = {
    id: React.PropTypes.string,
    emptyContent: React.PropTypes.any,
  }

  render() {
    const { viewable } = this.context;
    const { id, emptyContent = null } = this.props;

    if (viewable && !viewable(id)) {
      return emptyContent;
    }

    return React.Children.only(this.props.children);
  }
}



// WEBPACK FOOTER //
// ./src/permission/Permissable.jsx